/**
 * The unified app's primary-nav IA (the left rail model) — FLAT.
 *
 * Each top-level module (Chat / CRM / Hotel Supplier Management / Expense) is a
 * single rail item. Modules with multiple pages (CRM, Hotel Supplier) present
 * those pages as an Expense-style pill-tab bar ACROSS THE TOP of the module page
 * (see CrmModuleShell), NOT as nested rail items — so the rail stays flat and
 * every module works like the Expense surface.
 *
 * Gating (nav-gating.ts): Chat/CRM/Expense gate by surface; Hotel Supplier
 * additionally gates by a module authority (view:supplier_tab). Per-page visibility
 * within a module is handled by its tab bar. Admin (appended by ShellLayout) is
 * not part of this list.
 */
import type { NavItem } from '@andavo/web-ui';
import {
  ChartPieSliceIcon,
  ChatCircleIcon,
  ReceiptIcon,
  StorefrontIcon,
  UsersThreeIcon,
} from '@phosphor-icons/react';

export const platformNav: NavItem[] = [
  { icon: <ChatCircleIcon />, label: 'Chat', path: '/chat' },
  { icon: <UsersThreeIcon />, label: 'Customer Management', path: '/crm' },
  {
    icon: <StorefrontIcon />,
    label: 'Hotel Supplier Management',
    path: '/hotel-supplier',
  },
  {
    icon: <ChartPieSliceIcon />,
    label: 'CSM Staffing',
    path: '/csm-staffing',
  },
  { icon: <ReceiptIcon />, label: 'Expense', path: '/expense' },
];
